export default __webpack_public_path__ + "static/media/founding_member.e84ca6e6.png";